import { Link, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react"
import axios from "axios";
import { linksurl, api } from '../../../apis/urls'
//import { linkscurl } from '../../../apis/urls'
import Loader from '../../../common-components/loader'
import { decode } from "html-entities";
import ReactPaginate from 'react-paginate';
import { $ } from "react-jquery-plugin";


const LinkComponent =()=> {

    let navigate = useNavigate();

    let token = "Bearer "+localStorage.getItem('token');
    // console.log(token)

    const instance = axios.create({
        baseURL: linksurl,
        timeout: 1000000,
        headers: {'authorization': token}
      });


// list

        useEffect(() => {
            setLoader(true);
            $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
            setTimeout(() => {
                Listing();
                });
        }, []);

    const [loader,setLoader] = useState(false);
    const [linkList, setLinkList, setdescription] = useState([]);
    const [searchTitle, setSearchTitle] = useState("");
    const [link_url, setLink_url] = useState('');
    const [currentpage, setCurrentpage] = useState([]);
    const [totalPages, setTotalPages] = useState([]);
    const [totalItems, setTotalItems] = useState([]);

    let urole = localStorage.getItem('userrole');


    let counts = 0;
    if(linkList)
    {
        counts = linkList.length;
    }


    // console

    
    const Listing = (() => {
      instance.get('').then(res => {

        if(res.data.message === "Success"){            
            setLinkList(res.data.data.items.sort((a, b) => b.createdAt.localeCompare(a.createdAt)));
            setLink_url(res.data.data.items.link_url);
            setCurrentpage(res.data.data.currentPage)
            setTotalPages(res.data.data.totalPages)
            setTotalItems(res.data.data.totalItems)
        }else{
            setLinkList(false)
        }
        setLoader(false) 


            console.log("ssss", res.data.data.items)

      });
    });

    

// delete
    const URI = linksurl
    const removeAccreditations = (id) => {
        let r = window.confirm("Are you sure you want to delete this Link?");
        if(r == true){
        try {

            instance.delete(`${URI}/${id}`).then((response) =>{
                Listing();
                navigate("/links")
            })
            console.log('Item successfully deleted.')
        } catch (error) {
          alert(error)
          console.log(error)
        }
      }
    }

    const refreshList = () => {
        setLinkList(null);
    };


    const instances = axios.create({
        baseURL: api,
        timeout: 1000000,
        headers: {'authorization': token}
    });

    const findByTitles = name => {
        return instances.get(`links?search=${name}`);
    };

    const onChangeSearchTitle = (e) => {
        const searchTitle = e.target.value;
        setSearchTitle(searchTitle);
        findByTitles(searchTitle)
          .then(response => {
            if(response.data.message=== "Success"){
                setLinkList(response.data.data.items);
            }else{
                setLinkList(false)
            }
            console.log(response.data.data);
          })
          .catch(e => {
            console.log(e);
          });
    };

    const findByTitlesss = option => {
        return instances.get(`links?status=${option}`);
    };

    const onChangeSearchTitles = (e) => {
        const searchTitle = e.target.value;
        findByTitlesss(searchTitle)
          .then(response => {
            if(response.data.message=== "Success"){
                setLinkList(response.data.data.items);
            }else{
                setLinkList(false)
            }
            console.log(response.data.data);
          })
          .catch(e => {
            console.log(e);
          });
    };

    //PAGINATION


     // Invoke when user click to request another page.
     const handlePageClick = (event) => { console.log('EVENTSSS',event)

     const instance = axios.create({
         baseURL: linksurl+'?page='+event.selected+'&size='+10,
         timeout: 1000000,
         headers: {'authorization': token}
       });

       

     instance.get('').then(res => {

        setLinkList(res.data.data.items)

     
         setLoader(false);
     }).catch(e => {
     //console.log('errorshw',e);
     localStorage.removeItem('token')
     navigate("/")
     });

 };

      let sl=1
      const httpLink = "https://"
    return(
        <div>
        <aside className="right-side areas">    
            <div className="content-area dash-contentss">
                          <div className="page-title-wrpr">
                <div className="page-title-left-column">
                    <i className="icon-library1"></i>
                    <h2 className="page-title"> Links</h2>
                </div>
                <div className="page-rightside-action-column">
                <div className="input-groups mt-3 mb-3 search-grp">
                    <div className="input-group-prepends">
                    <select className="form-controls custom-select" onChange={onChangeSearchTitles}>
                            <option value="none" selected disabled hidden>STATUS</option>
                            <option value=" ">ALL</option>
                            <option>ACTIVE</option>
                            <option>INACTIVE</option>
                            <option>DELETE</option>
                        </select> 
                    </div>
                    <input type="text" 
                    className="form-controls search-bar"             
                    value={searchTitle}
                    onChange={onChangeSearchTitle}
                    placeholder="Search" />
                    <button  className="btn btn-search icon-search"></button>
                    </div>
                    {urole === "SUPERADMIN"?
                    <Link to="/add_links" data-toggle="tooltip" title="" class="addbtnitem-link text-anchor" data-original-title="Add New School"><i class="icon-add"></i><span>Add New Link</span> </Link>:null
                    }
                    </div>
            </div>
             
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Links</li>
              </ol>
            </nav>
            {linkList?
            (<div class="number-of">
                Displaying 1-{counts} of {totalItems} results.
            </div>):null
            }



            <div className="faculty-list-wrpr list-wrpr">
            {linkList?(
            linkList?.map((item,index) =>
                <div className="list faculty" key={index}>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="update-date">
                                <span className="date-wrpr">{sl++}</span>
                                <span className="desig">Sl.No</span>
                            </div>
                        </div>
                        <div className="col-md-5">
                            {/* <div className="faculty-user">Link Title
                                <span className="desig">
                                    <a href={decode(item.link_url)} target={item.link_target}>{decode(item.link_text)}</a>
                                </span>
                            </div>      */}
                            <div className="update-date">
                                <span className="date-wrpr"><a href={decode(item.link_url)} target={item.link_target}>{decode(item.link_text)}</a></span>
                                <span className="desig">Link Title</span>
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="update-date">
                                <span className="date-wrpr">{item.status}</span>
                                <span className="desig">Status</span>            
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="list-action-wrpr text-right  roundicons-text">
                                <Link  to={"/linkview/"+item.id} title="View" ><i style={{backgroundColor:'#eabb73'}}  className="view icon-eye"></i><span>View</span></Link>
                            </div>
                        </div>
                    </div>                   
                </div>
                )):null}

            </div>
                {linkList?
                    (<div class="number-of footer-number">
                        Displaying 1-{counts} of {totalItems} results.
                    </div>):null
                }
                {
                    !linkList?
                    (<div className="nodata">
                        <h2>Sorry! No Links Found</h2>
                    </div>):''
                }

                { 
                    loader?
                    <div>
                        <div className="loader_container"><Loader/></div>
                    </div>
                    :
                    null
                }

                {linkList?
                <div class="pagination-wrpr">
                    <ReactPaginate
                            className="pagination page"
                            pageClassName="page-item"
                            activeClassName="active"
                            nextLabel=">"
                            previousLabel="<"
                            previousClassName="page-link p-link"
                            nextClassName="page-link p-link"
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={10}
                            pageCount={totalPages}
                            renderOnZeroPageCount={1}
                        />
                </div>:null}  
    
        </div>
        </aside>
    </div>
    );
}

export default LinkComponent;
